import dayjs from 'dayjs';

import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import './targetInformation.scss';
import { Text } from '../../../../../../shared/uiComponents';
import { TEXT } from '../../../../../../shared/Helpers/colors';

interface TargetInfoProperties {
	item: TargetProperties;
}

const TargetInformation = ({ item }: TargetInfoProperties) => {
	const formatDate = (value?: string) => (value ? dayjs(value).format('MM/DD/YYYY') : '-');

	const formatPercent = (value: number | null | undefined) => (typeof value === 'number' ? `${value}%` : '-');

	const formatText = (value?: string | null) => (value && value.trim() !== '' ? value : '-');

	return (
		<div className="targetInformation">
			<div className="targetDetailsGrid">
				<div className="targetDetailsItem">
					<Text title="Response Rate" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatPercent(item.responsePercentage)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="Date Opened" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatDate(item.dateOpened)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="Date Mastered" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatDate(item.dateMastered)} type="pxs" color={TEXT.TERTIARY} />
				</div>

				<div className="targetDetailsItem">
					<Text title="Target Type" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.type?.name)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="Mastery Type" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.masteryCriteria?.name)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="Consecutive Days" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={item.consecutiveDays ?? '-'} type="pxs" color={TEXT.TERTIARY} />
				</div>

				<div className="targetDetailsItem">
					<Text title="Target Instructions" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.targetInstructions)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="SD" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.sd)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				{/* <div className="targetDetailsItem">
          <Text title='Goal Name' type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
          <Text title={formatText(item.goalName)} type="pxs" color={TEXT.TERTIARY} />
        </div> */}

				<div className="targetDetailsItem">
					<Text title="Error Correction" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.errorCorrection)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem">
					<Text title="Reinforcement" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={formatText(item.reinforcement)} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsItem targetDetailsItem--empty" />
			</div>
		</div>
	);
};

export default TargetInformation;
